import { Phone, MessageCircle, MapPin, Globe, Mail } from "lucide-react";
import { Reveal, SectionHeading } from "../components/primitives";
import { PageHero } from "../components/sections";
import { LeadForm } from "../components/LeadModal";
import { SITE, waLink } from "../data/site";
import { track } from "../lib/track";

const Contact = () => (
  <>
    <PageHero
      eyebrow="Contact DWC"
      lines={["Talk To A Real Person", "About Your Driving."]}
      text="Call, WhatsApp or book an appointment — the DWC team will understand your situation and suggest the right starting point."
    />
    <section className="bg-white py-24 md:py-32">
      <div className="mx-auto grid max-w-7xl gap-14 px-5 lg:grid-cols-[1fr_1.1fr] lg:px-8">
        <div>
          <SectionHeading eyebrow="Reach Us" number="01" title="Drive With Confidence — Mumbai, Surat & Ahmedabad" />
          <div className="mt-10 space-y-4">
            <a href={SITE.phoneHref} data-testid="contact-phone" onClick={() => track("phone_click", { source: "contact" })} className="flex items-center gap-4 rounded-2xl border border-gray-100 bg-white p-5 shadow-[0_4px_16px_rgb(0,0,0,0.03)] transition-colors hover:border-dwc-green/30">
              <span className="flex h-11 w-11 items-center justify-center rounded-xl bg-dwc-soft text-dwc-green"><Phone className="h-5 w-5" aria-hidden="true" /></span>
              <span>
                <span className="block text-[11px] font-bold uppercase tracking-wider text-dwc-charcoal/50">New Customer Inquiry</span>
                <span className="block text-base font-extrabold text-dwc-charcoal">{SITE.phoneDisplay}</span>
              </span>
            </a>
            <a href={SITE.phone2Href} data-testid="contact-phone-2" onClick={() => track("phone_click", { source: "contact_2" })} className="flex items-center gap-4 rounded-2xl border border-gray-100 bg-white p-5 shadow-[0_4px_16px_rgb(0,0,0,0.03)] transition-colors hover:border-dwc-green/30">
              <span className="flex h-11 w-11 items-center justify-center rounded-xl bg-dwc-soft text-dwc-green"><Phone className="h-5 w-5" aria-hidden="true" /></span>
              <span>
                <span className="block text-[11px] font-bold uppercase tracking-wider text-dwc-charcoal/50">Existing Customer</span>
                <span className="block text-base font-extrabold text-dwc-charcoal">{SITE.phone2Display}</span>
              </span>
            </a>
            <a href="tel:+917778833333" data-testid="contact-franchise-phone" onClick={() => track("phone_click", { source: "contact_franchise" })} className="flex items-center gap-4 rounded-2xl border border-gray-100 bg-white p-5 shadow-[0_4px_16px_rgb(0,0,0,0.03)] transition-colors hover:border-dwc-green/30">
              <span className="flex h-11 w-11 items-center justify-center rounded-xl bg-dwc-soft text-dwc-green"><Phone className="h-5 w-5" aria-hidden="true" /></span>
              <span>
                <span className="block text-[11px] font-bold uppercase tracking-wider text-dwc-charcoal/50">Franchise Inquiry</span>
                <span className="block text-base font-extrabold text-dwc-charcoal">+91 77788 33333</span>
              </span>
            </a>
            <a href={waLink()} target="_blank" rel="noopener noreferrer" data-testid="contact-whatsapp" onClick={() => track("whatsapp_click", { source: "contact" })} className="flex items-center gap-4 rounded-2xl border border-gray-100 bg-white p-5 shadow-[0_4px_16px_rgb(0,0,0,0.03)] transition-colors hover:border-dwc-green/30">
              <span className="flex h-11 w-11 items-center justify-center rounded-xl bg-dwc-green text-white"><MessageCircle className="h-5 w-5" aria-hidden="true" /></span>
              <span>
                <span className="block text-[11px] font-bold uppercase tracking-wider text-dwc-charcoal/50">WhatsApp</span>
                <span className="block text-base font-extrabold text-dwc-charcoal">{SITE.phoneDisplay}</span>
              </span>
            </a>
            <div className="flex items-center gap-4 rounded-2xl border border-gray-100 bg-white p-5 shadow-[0_4px_16px_rgb(0,0,0,0.03)]">
              <span className="flex h-11 w-11 items-center justify-center rounded-xl bg-dwc-soft text-dwc-green"><MapPin className="h-5 w-5" aria-hidden="true" /></span>
              <span>
                <span className="block text-[11px] font-bold uppercase tracking-wider text-dwc-charcoal/50">Location</span>
                <span className="block text-base font-extrabold text-dwc-charcoal">{SITE.city}</span>
              </span>
            </div>
            {SITE.email && (
              <a href={`mailto:${SITE.email}`} data-testid="contact-email" className="flex items-center gap-4 rounded-2xl border border-gray-100 bg-white p-5 shadow-[0_4px_16px_rgb(0,0,0,0.03)] transition-colors hover:border-dwc-green/30">
                <span className="flex h-11 w-11 items-center justify-center rounded-xl bg-dwc-soft text-dwc-green"><Mail className="h-5 w-5" aria-hidden="true" /></span>
                <span>
                  <span className="block text-[11px] font-bold uppercase tracking-wider text-dwc-charcoal/50">Email</span>
                  <span className="block text-base font-extrabold text-dwc-charcoal">{SITE.email}</span>
                </span>
              </a>
            )}
            <a href={SITE.url} target="_blank" rel="noopener noreferrer" data-testid="contact-website" className="flex items-center gap-4 rounded-2xl border border-gray-100 bg-white p-5 shadow-[0_4px_16px_rgb(0,0,0,0.03)] transition-colors hover:border-dwc-green/30">
              <span className="flex h-11 w-11 items-center justify-center rounded-xl bg-dwc-soft text-dwc-green"><Globe className="h-5 w-5" aria-hidden="true" /></span>
              <span>
                <span className="block text-[11px] font-bold uppercase tracking-wider text-dwc-charcoal/50">Website</span>
                <span className="block text-base font-extrabold text-dwc-charcoal">drivewithconfidence.in</span>
              </span>
            </a>
          </div>
        </div>
        <Reveal delay={0.15}>
          <div className="rounded-3xl border border-dwc-green/15 bg-dwc-soft p-7 md:p-10">
            <p className="text-xs font-bold uppercase tracking-[0.25em] text-dwc-crimson">Appointment</p>
            <h2 className="mt-2 text-2xl font-extrabold tracking-tight text-dwc-charcoal">Book an Appointment</h2>
            <p className="mt-2 text-sm text-dwc-charcoal/65">Fill this in and the DWC team will contact you shortly.</p>
            <div className="mt-7 rounded-2xl bg-white p-6 shadow-[0_8px_30px_rgb(0,0,0,0.05)] md:p-7">
              <LeadForm inline />
            </div>
          </div>
        </Reveal>
      </div>
    </section>
  </>
);

export default Contact;
